var _g, _g2, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBoleto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 48,
    viewBox: "0 0 75 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2056_9516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.87891 8.34375H11.8029V39.4847H8.87891V8.34375ZM20.507 39.4847V8.34375H14.659V39.4847H20.507ZM23.363 8.34375H26.2871V39.4847H23.363V8.34375ZM29.2111 8.34375H32.0671V39.4847H29.2111V8.34375ZM8.87891 42.5478H43.6952V45.6838H8.87891V42.5478ZM40.7712 8.34375H37.9152V39.4847H43.6952V8.34375H40.7712Z",
    fill: "#5B6772"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2056_9516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6953 8.34375H46.4658V39.4847H43.6953V8.34375ZM54.7127 39.4847V8.34375H49.1718V39.4847H54.7127ZM57.4187 8.34375H60.1892V39.4847H57.4187V8.34375ZM62.9596 8.34375H65.6657V39.4847H62.9596V8.34375ZM43.6953 42.5478H76.6831V45.6838H43.6953V42.5478ZM73.9126 8.34375H71.2066V39.4847H76.6831V8.34375H73.9126Z",
    fill: "#5B6772"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.97656,
    y: 1.5,
    width: 71.4348,
    height: 44.6848,
    rx: 3.5,
    stroke: "#5B6772",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2056_9516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.8163,
    height: 30.9951,
    fill: "white",
    transform: "translate(8.87891 8.34375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2056_9516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.8107,
    height: 30.9951,
    fill: "white",
    transform: "translate(43.6953 8.34375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoleto);
export default __webpack_public_path__ + "static/media/icon-boleto.493c1742b1efd5f92980774735a88e7e.svg";
export { ForwardRef as ReactComponent };